import { useParams } from 'react-router-dom';
import { Stack, Flex, Text, Divider } from '@chakra-ui/react';

import { toMoney } from 'src/legacy/Utils/Conversor';

import { RouteParamsEvent } from 'src/types/routing';

import { useCartStore, useDiscountStore } from '../../stores';

type Props = {
  total: number;
  totalTickets: number;
  totalCreditCardFee: number;
  totalPixFee: number;
  totalDiscount: number;
  isCouponApplied: boolean;
};
export const CheckoutSummary = ({
  total,
  totalTickets,
  totalCreditCardFee,
  totalPixFee,
  totalDiscount,
  isCouponApplied,
}: Props) => {
  const { eventID } = useParams<RouteParamsEvent>();
  const { getEventCart } = useCartStore();
  const { discount } = useDiscountStore();

  const installmentFee = !!totalPixFee
    ? 0
    : total - (totalTickets + totalCreditCardFee - totalDiscount);
  const hasInstallmentFee = Math.round(installmentFee) > 0;
  const diffFees = totalCreditCardFee - totalPixFee;

  if (!eventID) return null;

  return (
    <Stack spacing={3}>
      {getEventCart(eventID)
        ?.filter(cartItem => cartItem.quantity > 0)
        .map(cartItem => (
          <Flex key={cartItem.ticketTypeId} justify="space-between">
            <Text wordBreak="break-word">{`${cartItem.quantity} x ${cartItem.name}`}</Text>
            <Text>{toMoney(cartItem.quantity * cartItem.price)}</Text>
          </Flex>
        ))}
      {hasInstallmentFee && (
        <Flex justify="space-between">
          <Text>Taxa do parcelamento</Text>
          <Text>{toMoney(installmentFee)}</Text>
        </Flex>
      )}
      <Divider border="1px" borderColor="gray.50" />
      <Flex justify="space-between">
        <Text>{hasInstallmentFee ? 'Outras taxas' : 'Total de taxas'}</Text>
        <Text>{toMoney(totalCreditCardFee)}</Text>
      </Flex>
      {diffFees !== totalCreditCardFee && diffFees > 0 && (
        <Flex justify="space-between">
          <Text>Desconto PIX</Text>
          <Text color="green.500">{`- ${toMoney(diffFees)}`}</Text>
        </Flex>
      )}
      {isCouponApplied && !!discount && (
        <Flex justify="space-between">
          <Text>{`Cupom "${discount.name}"`}</Text>
          <Text color="green.500">{`- ${toMoney(totalDiscount)}`}</Text>
        </Flex>
      )}
      <Divider border="1px" borderColor="gray.50" />
      <Flex fontWeight="bold" justify="space-between">
        <Text>Total</Text>
        <Text>
          <>{total > 0 ? <>{toMoney(total)}</> : <>Gratuito</>}</>
        </Text>
      </Flex>
    </Stack>
  );
};
